'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dReference$0024 from "./app.api.-General-Practice-User-Reference$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeUserFullReference$$anon$13() {
}
export { $c_Lapp_api_GeneralPracticeUserFullReference$$anon$13 as $c_Lapp_api_GeneralPracticeUserFullReference$$anon$13 };
$c_Lapp_api_GeneralPracticeUserFullReference$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeUserFullReference$$anon$13.prototype.constructor = $c_Lapp_api_GeneralPracticeUserFullReference$$anon$13;
/** @constructor */
function $h_Lapp_api_GeneralPracticeUserFullReference$$anon$13() {
}
export { $h_Lapp_api_GeneralPracticeUserFullReference$$anon$13 as $h_Lapp_api_GeneralPracticeUserFullReference$$anon$13 };
$h_Lapp_api_GeneralPracticeUserFullReference$$anon$13.prototype = $c_Lapp_api_GeneralPracticeUserFullReference$$anon$13.prototype;
$c_Lapp_api_GeneralPracticeUserFullReference$$anon$13.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeUserFullReference$$anon$13.prototype.apply__O = (function() {
  return $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dReference$0024.$m_Lapp_api_GeneralPracticeUserReference$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_GeneralPracticeUserFullReference$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeUserFullReference$$anon$13, "app.api.GeneralPracticeUserFullReference$$anon$13", ({
  Lapp_api_GeneralPracticeUserFullReference$$anon$13: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeUserFullReference$$anon$13 as $d_Lapp_api_GeneralPracticeUserFullReference$$anon$13 };
//# sourceMappingURL=app.api.-General-Practice-User-Full-Reference$$anon$13.js.map
